import { useMemo } from "react";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { useAllAttachedItems } from "@coworker/apprestructured/src/task-management/services/useAllAttachedItems";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import {
  isLoading,
  LOADING,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import ImagePreviewAddOn from "../../../TaskCreatorAndEditorSheet/ListItem/ImagePreviewAddOn/ImagePreviewAddOn";

export type ImagesCarouselCardFragmentConfigProps = {
  field: string;
};

type ImagesCarouselCardFragmentProps = {
  configProps: ImagesCarouselCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function ImagesCarouselCardFragment({
  configProps,
  commonProps,
}: ImagesCarouselCardFragmentProps) {
  const { field } = configProps;
  const { task } = commonProps;

  const rawItems = getTypedValue<ItemNoAndType[] | Loading>(
    getByPath(task, field)
  );

  const itemNosAndType: ItemNoAndType[] | Loading = isLoading(rawItems)
    ? LOADING
    : Array.isArray(rawItems)
      ? rawItems
      : [];

  const { items, isFetchingItems } = useAllAttachedItems(itemNosAndType);

  const urls = useMemo<string[] | Loading>(() => {
    if (isLoading(itemNosAndType) || isFetchingItems) {
      return LOADING;
    }

    return items
      .map((item) => item.smallImageUrl ?? item.imageUrl ?? "")
      .filter((url): url is string => Boolean(url));
  }, [itemNosAndType, isFetchingItems, items]);

  return <ImagePreviewAddOn srcs={urls} />;
}

export default ImagesCarouselCardFragment;
